__turbopack_context__.v({
  "glyph": "_6Pfi_q_glyph",
  "inherit": "_6Pfi_q_inherit",
  "large": "_6Pfi_q_large",
  "medium": "_6Pfi_q_medium",
  "small": "_6Pfi_q_small",
});
